import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}

import {
  ref,
  onMounted,
  onBeforeUnmount,
  inject,
  watch,
  computed,
  reactive,
} from "vue";
import { displayService } from "@/_services/display.service";
import Widget from "@/components/dynamic/Widget.vue";
import { useI18n } from "vue-i18n";
import html2canvas from "html2canvas";

interface EchoInstance {
  connector: {
    pusher: {
      connection: {
        state: string;
      };
      connect: () => void;
      disconnect: () => void;
    };
  };
  channel: (name: string) => {
    listen: (event: string, callback: (data: any) => void) => void;
  };
}

// Inject dependencies

export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicPage',
  setup(__props) {

const echo = inject("echo") as EchoInstance;
const display = inject("display");
const snd = inject("snd") as HTMLAudioElement | null;
const audioNotification = inject(
  "audioNotification2"
) as HTMLAudioElement | null;

const springAudio = inject("audioNotification") as HTMLAudioElement | null;
const airportNotification = inject("airportAudio") as HTMLAudioElement | null;
const toneSound = inject("toneSound") as HTMLAudioElement | null;

const config = ref<any>({});
const items = ref<any[]>([]);
const bgColor = ref("#f8f9fa");
const screenDimension = ref("");
const isConnected = ref(false);
const onLine = ref(navigator.onLine);
const connectionInterval = ref<number | null>(null);

const containerWrapper = ref<HTMLElement | null>(null);
const containerWidth = ref(1280);
const containerHeight = ref(720);

const queueConf = reactive({
  counterTxt: "",
  numberTxt: "",
  numberHeaderColor: "",
  numberBgColor: "",
  numberTxtColor: "",
  counterHeaderColor: "",
  counterBgColor: "",
  counterTxtColor: "",
  queueData: [],
});

const queueData = ref<any[]>([]);
const blackScreen = ref(false);
const voices_to_play = ref<string[]>([]);
const voice_is_playing = ref(false);

let pingInterval: number | null = null;

function getDisplayQueues(queues: any): void {
  displayService.getInServiceTickets(queues).then((data: any) => {
    if (data && data.tickets && data.tickets.length > 0) {
      queueData.value = data.tickets.map((ticket: any) => ({
        ticket: ticket.public_identifier,
        counter: ticket.counter_name,
        id: ticket.id,
      }));
    } else {
      queueData.value = [];
    }
  });
}

async function callDisplayedVideos(queues: any) {
  console.log("queues !!!", queues);
  try {
    let formData = new FormData();
    formData.append("queue_id", queues);
    await displayService.callDisplayedVideos(formData);
  } catch (e) {
    console.log("error getting displayed videos tags");
  }
}

function setupQueueListeners(displayId: any): void {
  if (!echo) return;
  const channel = echo.channel(`private-display-${displayId}`);
  if (!channel) return;
  (channel as any)
    .listen(".ticket-call", (data: any) => {
      updateQueueDataFromSocket(data);
    })
    .listen(".ticket-recall", (data: any) => {
      updateQueueDataFromSocket(data);
    })
    .listen(".black-screen", (data: any) => {
      if (data.status) {
        blackScreen.value = true;
      } else {
        blackScreen.value = false;
      }
    });
}

function buildVoiceText(data: any) {
  let text = "";
  if (localStorage.getItem("number") && localStorage.getItem("counter")) {
    const counterData = JSON.parse(localStorage.getItem("counter") || "{}");
    const numberData = JSON.parse(localStorage.getItem("number") || "{}");

    // if we have queue-specific voices
    if (counterData.queueVoices && data.queue_line_id) {
      const queueVoice = counterData.queueVoices.find(
        (voice: any) => voice.queueId === data.queue_line_id
      );
      if (queueVoice) {
        text =
          numberData.voice +
          data.num_voice +
          queueVoice.voice +
          data.counter_voice;
      } else {
        text =
          numberData.voice +
          data.num_voice +
          counterData.voice +
          data.counter_voice;
      }
    } else {
      text =
        numberData.voice +
        data.num_voice +
        counterData.voice +
        data.counter_voice;
    }
  }
  return text;
}

function playVoices() {
  if (voices_to_play.value.length === 0 || voice_is_playing.value) return;
  voice_is_playing.value = true;

  const queueItem = items.value.find((item: any) => item.appType === "queue");
  if (queueItem) {
    
    if (queueItem?.enableNotificationSound == false) {
      if (snd) {
        snd.src = "data:audio/mpeg;base64," + voices_to_play.value[0];
        snd.play()
          .then(() => {
            snd.onended = () => {
              voice_is_playing.value = false;
              voices_to_play.value.splice(0, 1);
              if (voices_to_play.value.length > 0) {
                playVoices();
              }
            };
          })
          .catch((err) => {
            // Silently handle NotAllowedError or any play error
            voice_is_playing.value = false;
            voices_to_play.value.splice(0, 1);
          });
      } else {
        voice_is_playing.value = false;
        voices_to_play.value.splice(0, 1);
      }
      return; // don't play notification sound, just the voice
    }

    const notificationSound = queueItem?.notificationSound || "default";
    if (notificationSound == "slow-spring") {
      if (springAudio) {
        springAudio.currentTime = 0;
        springAudio.play()
          .then(() => {
            springAudio.onended = () => {
              if (snd) {
                snd.src = "data:audio/mpeg;base64," + voices_to_play.value[0];
                snd.play()
                  .then(() => {
                    snd.onended = () => {
                      voice_is_playing.value = false;
                      voices_to_play.value.splice(0, 1);
                      if (voices_to_play.value.length > 0) {
                        playVoices();
                      }
                    };
                  })
                  .catch((err) => {
                    voice_is_playing.value = false;
                    voices_to_play.value.splice(0, 1);
                  });
              } else {
                voice_is_playing.value = false;
                voices_to_play.value.splice(0, 1);
              }
            };
          })
          .catch((err) => {
            // Silently handle NotAllowedError or any play error
            voice_is_playing.value = false;
            voices_to_play.value.splice(0, 1);
          });
      }
    } else if (notificationSound == "default") {
      if (audioNotification) {
        audioNotification.currentTime = 0;
        audioNotification.play()
          .then(() => {
            audioNotification.onended = () => {
              if (snd) {
                snd.src = "data:audio/mpeg;base64," + voices_to_play.value[0];
                snd.play()
                  .then(() => {
                    snd.onended = () => {
                      voice_is_playing.value = false;
                      voices_to_play.value.splice(0, 1);
                      if (voices_to_play.value.length > 0) {
                        playVoices();
                      }
                    };
                  })
                  .catch((err) => {
                    voice_is_playing.value = false;
                    voices_to_play.value.splice(0, 1);
                  });
              } else {
                voice_is_playing.value = false;
                voices_to_play.value.splice(0, 1);
              }
            };
          })
          .catch((err) => {
            voice_is_playing.value = false;
            voices_to_play.value.splice(0, 1);
          });
      }
    } else if (notificationSound == "airport") {
      if (airportNotification) {
        airportNotification.currentTime = 0;
        airportNotification.play()
          .then(() => {
            airportNotification.onended = () => {
              if (snd) {
                snd.src = "data:audio/mpeg;base64," + voices_to_play.value[0];
                snd.play()
                  .then(() => {
                    snd.onended = () => {
                      voice_is_playing.value = false;
                      voices_to_play.value.splice(0, 1);
                      if (voices_to_play.value.length > 0) {
                        playVoices();
                      }
                    };
                  })
                  .catch((err) => {
                    voice_is_playing.value = false;
                    voices_to_play.value.splice(0, 1);
                  });
              } else {
                voice_is_playing.value = false;
                voices_to_play.value.splice(0, 1);
              }
            };
          })
          .catch((err) => {
            voice_is_playing.value = false;
            voices_to_play.value.splice(0, 1);
          });
      }
    } else if (notificationSound == "tone") {
      if (toneSound) {
        toneSound.currentTime = 0;
        toneSound.play()
          .then(() => {
            toneSound.onended = () => {
              if (snd) {
                snd.src = "data:audio/mpeg;base64," + voices_to_play.value[0];
                snd.play()
                  .then(() => {
                    snd.onended = () => {
                      voice_is_playing.value = false;
                      voices_to_play.value.splice(0, 1);
                      if (voices_to_play.value.length > 0) {
                        playVoices();
                      }
                    };
                  })
                  .catch((err) => {
                    voice_is_playing.value = false;
                    voices_to_play.value.splice(0, 1);
                  });
              } else {
                voice_is_playing.value = false;
                voices_to_play.value.splice(0, 1);
              }
            };
          })
          .catch((err) => {
            voice_is_playing.value = false;
            voices_to_play.value.splice(0, 1);
          });
      }
    }
  } else {
    if (audioNotification) {
      audioNotification.currentTime = 0;
      audioNotification.play()
        .then(() => {
          audioNotification.onended = () => {
            if (snd) {
              snd.src = "data:audio/mpeg;base64," + voices_to_play.value[0];
              snd.play()
                .then(() => {
                  snd.onended = () => {
                    voice_is_playing.value = false;
                    voices_to_play.value.splice(0, 1);
                    if (voices_to_play.value.length > 0) {
                      playVoices();
                    }
                  };
                })
                .catch((err) => {
                  voice_is_playing.value = false;
                  voices_to_play.value.splice(0, 1);
                });
            } else {
              voice_is_playing.value = false;
              voices_to_play.value.splice(0, 1);
            }
          };
        })
        .catch((err) => {
          voice_is_playing.value = false;
          voices_to_play.value.splice(0, 1);
        });
    } else {
      voice_is_playing.value = false;
      voices_to_play.value.splice(0, 1);
    }
  }
}

function updateQueueDataFromSocket(data: any): void {
  if (data.in_service) {
    queueData.value = data.in_service.map((ticket: any) => ({
      ticket: ticket.public_identifier,
      counter: ticket.counter_name,
      id: ticket.id,
    }));
  }
  // --- AUDIO LOGIC ---
  const voiceText = buildVoiceText(data);
  if (voiceText) {
    voices_to_play.value.push(voiceText);
    playVoices();
  }
}
const locale = ref("");
const initDisplay = (): void => {
  const displayData = JSON.parse(localStorage.getItem("display") || "{}");
  if (displayData) {
    config.value = displayData.config_screen || "{}";
    const parts = displayData.dimension.split("x");
    if (parts.length === 2) {
      const width = parseInt(parts[0]);
      const height = parseInt(parts[1]);
      if (!isNaN(width) && !isNaN(height)) {
        containerWidth.value = width;
        containerHeight.value = height;
      }
    }
    if (config.value) {
      parseConfigScreen(config.value, displayData);

      //language
      const conf = JSON.parse(displayData.config);
      locale.value = conf.locale;
      localStorage.setItem("Language", locale.value);
    } else {
      console.warn("No config_screen found in display config");
    }
  }
};

const { t } = useI18n();

const parseConfigScreen = (configScreen: any, displayData: any): void => {
  if (configScreen?.bgColor) {
    bgColor.value = configScreen?.bgColor;
  }
  if (configScreen?.items && Array.isArray(configScreen?.items)) {
    items.value = configScreen?.items;
  } else {
    items.value = [];
  }
  const config = JSON.parse(displayData.config);
  if (config.queues) {
    const queueItem = items.value.find((item: any) => item.appType === "queue");
    console.log("queueItem", queueItem);
    if (queueItem) {
      const queueConfig = queueItem.queueConfig;
      queueConf.counterBgColor = queueConfig.counterBgColor;
      queueConf.counterHeaderColor = queueConfig.counterHeaderColor;
      queueConf.counterTxtColor = queueConfig.counterTxtColor;
      queueConf.numberBgColor = queueConfig.numberBgColor;
      queueConf.numberHeaderColor = queueConfig.numberHeaderColor;
      queueConf.numberTxtColor = queueConfig.numberTxtColor;
    }
    const voiceCall = config.voice_call;
    if (voiceCall == 1) {
      queueConf.counterTxt = config.textCounter;
      queueConf.numberTxt = config.textNumber;
    } else {
      const lang = localStorage.getItem("Language");
      if (lang == "fr") {
        queueConf.counterTxt = "Guichet";
        queueConf.numberTxt = "Numéro";
      } else if (lang == "en") {
        queueConf.counterTxt = "Counter";
        queueConf.numberTxt = "Number";
      } else {
        queueConf.counterTxt = "شباك";
        queueConf.numberTxt = "رقم";
      }
    }
    // init queue data and listeners
    getDisplayQueues(config.queues || displayData.queues || "");
    setupQueueListeners(displayData.id);
    callDisplayedVideos(config.queues);
  }
};

const sortedItems = computed(() => {
  return [...items.value].sort((a, b) => {
    const zIndexA = a.zIndex || 1;
    const zIndexB = b.zIndex || 1;
    return zIndexB - zIndexA;
  });

});

const getItemStyle = (item: any) => {
  const x = getScaledPosition(item.x, "x");
  const y = getScaledPosition(item.y, "y");
  const width = getScaledSize(item.width || 200, "width");
  const height = getScaledSize(item.height || 150, "height");

  return {
    position: "absolute",
    left: `${x}px`,
    top: `${y}px`,
    width: `${width}px`,
    height: `${height}px`,
    zIndex: item.zIndex || 1,
    display: item.visible === false ? "none" : "block",
  };
};

const getScaledPosition = (value: number, axis: "x" | "y") => {
  if (!containerWrapper.value || value === undefined || value === null) {
    return value || (axis === "x" ? 100 : 100); // default position
  }

  const wrapperWidth = containerWrapper.value.clientWidth;
  const wrapperHeight =
    wrapperWidth * (containerHeight.value / containerWidth.value);

  if (axis === "x") {
    return (value / containerWidth.value) * wrapperWidth;
  } else {
    return (value / containerHeight.value) * wrapperHeight;
  }
};

const getScaledSize = (value: number, dimension: "width" | "height") => {
  if (!containerWrapper.value || value === undefined || value === null) {
    return dimension === "width" ? 200 : 150;
  }

  const wrapperWidth = containerWrapper.value.clientWidth;
  const wrapperHeight =
    wrapperWidth * (containerHeight.value / containerWidth.value);

  if (dimension === "width") {
    return (value / containerWidth.value) * wrapperWidth;
  } else {
    return (value / containerHeight.value) * wrapperHeight;
  }
};

const aspectRatioStyle = computed(() => {
  const ratio = (containerHeight.value / containerWidth.value) * 100;
  return {
    paddingBottom: `${ratio}%`,
  };
});

const scale = computed(() => {
  if (!containerWrapper.value) return 1;
  const wrapperWidth = containerWrapper.value.clientWidth;
  return wrapperWidth / containerWidth.value;
});

// cnx
const updateOnlineStatus = (e: Event) => {
  const { type } = e as { type: string };
  onLine.value = type === "online";
};

const checkConnection = () => {
  if (echo && echo.connector && echo.connector.pusher) {
    isConnected.value = echo.connector.pusher.connection.state === "connected";
    console.log(
      `WebSocket connection status: ${
        isConnected.value ? "connected" : "disconnected"
      }`
    );

    // reconnection
    if (!isConnected.value) {
      echo.connector.pusher.connect(); // attempting to reconnect
    }
  }
};

const setupWebSocketListeners2 = () => {
  if (display && echo) {
    const displayData = JSON.parse(localStorage.getItem("display") || "{}");
    echo
      .channel(`private-display-${displayData.id}`)
      .listen(".display-refresh", () => {
        console.log("Received refresh signal, reloading...");
        displayService.refresh().catch(function (err) {
          console.log(err);
        });
        setQueueData();
      });
  }
};

const setQueueData = () => {
  const displayData = JSON.parse(localStorage.getItem("display") || "{}");
  console.log("displayData !!!!", displayData);
};

const setupWebSocketListeners = () => {
  if (display && echo) {
    const displayData = JSON.parse(localStorage.getItem("display") || "{}");
    const channel = echo.channel(`private-display-${displayData.id}`);
    const eventHandlers = {
      ".display-refresh": () => {
        console.log("Received refresh signal, reloading...");
        displayService.refresh().catch(console.log);
      },
      ".display-tags-dispatch": (data: any) => {
        console.log("--------------------------------");
        console.log("data", data);
        const videoItem = displayData.config_screen.items.filter(
          (item: any) => item.type == "video"
        );
        if (videoItem.length > 0) {
          console.log("videoItem", videoItem.length);
          const videos = videoItem[0].src;
          console.log("videos", videos);
          if (videoItem[0].multiVideo) {
            const videoTags = data.tags;

            //match video tags with dispatch percentages
            const displayedVideos = videos
              .map((video: any) => {
                //find matching tags for this video
                const matchingTags = video.tags
                  .map((tag: any) => ({
                    percentage: videoTags[tag.id] || 0,
                    tag: tag,
                  }))
                  .filter((tagMatch: any) => tagMatch.percentage > 0);

                //if vid has matching tags=>include it with the highest %
                if (matchingTags.length > 0) {
                  const maxPercentage = Math.max(
                    ...matchingTags.map((t: any) => t.percentage)
                  );
                  return {
                    url: video.url,
                    percentage: maxPercentage,
                    tags: matchingTags,
                  };
                } else {
                  //vids with no matching tags with percentage 0
                  return {
                    url: video.url,
                    percentage: 0,
                    tags: video.tags.map((tag: any) => ({
                      percentage: 0,
                      tag: tag,
                    })),
                  };
                }
              })
              .sort((a: any, b: any) => b.percentage - a.percentage); //highest % first

            localStorage.setItem(
              "displayedVideos",
              JSON.stringify(displayedVideos)
            );
          }
        }
      },
    };

    Object.entries(eventHandlers).forEach(([event, handler]) => {
      channel.listen(event, handler);
    });
  }
};

watch(onLine, (isOnline) => {
  if (isOnline) {
    location.reload();
  }
});

//no inservice not waiting
// watch(queueData, (newVal) => {
//   if (Array.isArray(newVal) && newVal.length === 0) {
//     console.log("empty queue data");
//     localStorage.setItem("displayedVideos", JSON.stringify([]));
//   }
// });

function ping() {
  try {
    // Wait for next tick to ensure DOM is fully rendered
    setTimeout(() => {
      // Check if black screen is active
      if (blackScreen.value) {
        console.log("Black screen is active, skipping screenshot");
        return;
      }

      // Check if the container has proper dimensions
      const container = containerWrapper.value;
      if (
        !container ||
        container.offsetWidth === 0 ||
        container.offsetHeight === 0
      ) {
        console.log("Container has no dimensions, skipping screenshot");
        return;
      }

      // Check if there are items to display
      if (items.value.length === 0) {
        console.log("No items to display, skipping screenshot");
        return;
      }

      // Use the specific container instead of document.body for more reliable capture
      html2canvas(container, {
        scale: 1,
        useCORS: true,
        allowTaint: true,
        backgroundColor: bgColor.value || "#f8f9fa",
        width: container.offsetWidth,
        height: container.offsetHeight,
        logging: false, // Disable logging to reduce console noise
        ignoreElements: (element: Element) => {
          // Ignore elements that might cause issues
          const htmlElement = element as HTMLElement;
          return (
            htmlElement.style.display === "none" ||
            htmlElement.offsetWidth === 0 ||
            htmlElement.offsetHeight === 0 ||
            htmlElement.style.visibility === "hidden"
          );
        },
      })
        .then(function (canvas) {
          if (canvas.width === 0 || canvas.height === 0) {
            console.log(
              "Generated canvas has no dimensions, skipping screenshot"
            );
            return;
          }

          canvas.toBlob(
            function (blob) {
              if (!blob) return;
              let form = new FormData();
              var reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = function () {
                form.append("screenshot", reader.result as string);

                // systemInfo
                const systemInfo = localStorage.getItem("systemInfoList");
                if (systemInfo) {
                  form.append("health", systemInfo);
                  localStorage.removeItem("systemInfoList");
                }

                displayService.ping(form).catch(function (err) {
                  console.log(err);
                });
              };
            },
            "image/jpeg",
            0.05
          );
        })
        .catch(function (error) {
          console.log("html2canvas error:", error);
          // Fallback: try to send ping without screenshot
          try {
            let form = new FormData();
            form.append("screenshot", ""); // Empty screenshot

            // systemInfo
            const systemInfo = localStorage.getItem("systemInfoList");
            if (systemInfo) {
              form.append("health", systemInfo);
              localStorage.removeItem("systemInfoList");
            }

            displayService.ping(form).catch(function (err) {
              console.log("Fallback ping error:", err);
            });
          } catch (fallbackErr) {
            console.log("Fallback ping failed:", fallbackErr);
          }
        });
    }, 100); // Small delay to ensure DOM is ready
  } catch (err) {
    console.log("Ping function error:", err);
  }
}


const hiddenForQueueItem = computed(() =>
  items.value.find(item => item.hiddenForQueue === true)
);


const itemsToRender = computed(() => {
  if (queueData.value.length === 0) {
    return sortedItems.value;
  } else {
    return sortedItems.value.filter(item => item.hiddenForQueue !== true);
  }
});
onMounted(() => {
  localStorage.setItem("status", "dynamicPage");
  
  // Get screen dimensions in pixels
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  console.log(`Screen dimensions: ${screenWidth}x${screenHeight} pixels`);
  
  initDisplay();
  setupWebSocketListeners();
  checkConnection();
  connectionInterval.value = window.setInterval(checkConnection, 40000);
  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);

  // Delay the first ping to ensure the component is fully rendered
  setTimeout(() => {
    pingInterval = window.setInterval(ping, 300000); // 5 minutes
  }, 5000); // Wait 5 seconds before starting ping interval
});

onBeforeUnmount(() => {
  window.removeEventListener("online", updateOnlineStatus);
  window.removeEventListener("offline", updateOnlineStatus);

  if (connectionInterval.value) {
    clearInterval(connectionInterval.value);
  }

  if (pingInterval) {
    clearInterval(pingInterval);
  }

  if (display && echo) {
    const displayData = JSON.parse(localStorage.getItem("display") || "{}");
    const channel = echo.channel(`private-display-${displayData.id}`);
    if (channel) {
      (channel as any).stopListening(".ticket-call");
      (channel as any).stopListening(".ticket-recall");
      (channel as any).stopListening(".black-screen");
      (channel as any).stopListening(".display-refresh");
    }
  }
});

//bgColor
const getBackgroundStyle = (bgColor: string | undefined) => {
  console.log("bgColor", bgColor);
  if (!bgColor) return "#f8f9fa";

  // Check if it's a URL (image)
  if (
    bgColor.startsWith("http") ||
    bgColor.startsWith("data:image") ||
    bgColor.startsWith("/")
  ) {
    return `url('${bgColor}')`;
  }

  // Check if it's a gradient
  if (
    bgColor.includes("gradient") ||
    bgColor.includes("linear-gradient") ||
    bgColor.includes("radial-gradient")
  ) {
    return bgColor;
  }

  // Check if it's a hex color
  if (bgColor.startsWith("#")) {
    return bgColor;
  }

  // Check if it's a CSS color name or other valid color format
  if (
    bgColor.includes("rgb") ||
    bgColor.includes("hsl") ||
    bgColor.includes("rgba")
  ) {
    return bgColor;
  }

  // Default fallback
  return "#f8f9fa";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "preview-container-wrapper",
    ref_key: "containerWrapper",
    ref: containerWrapper
  }, [
    _createElementVNode("div", {
      class: "aspect-ratio-container",
      style: _normalizeStyle(aspectRatioStyle.value)
    }, [
      _createElementVNode("div", {
        class: "preview-container",
        style: _normalizeStyle({ background: getBackgroundStyle(bgColor.value) })
      }, [
        (items.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
              _createElementVNode("span", null, "No items", -1)
            ])))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsToRender.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "preview-item",
            style: _normalizeStyle(getItemStyle(item))
          }, [
            _createVNode(Widget, {
              hiddenForQueue: hiddenForQueueItem.value,
              config: item,
              queueData: queueData.value,
              queueConfig: queueConf,
              queueAudioPlaying: voice_is_playing.value,
              scale: scale.value
            }, null, 8, ["hiddenForQueue", "config", "queueData", "queueConfig", "queueAudioPlaying", "scale"])
          ], 4))
        }), 128))
      ], 4)
    ], 4)
  ], 512))
}
}

})